import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { DeliveryDiscountType } from '../enums/DeliveryDiscountType'

export class DeliveryDiscountFilterEntity {
  type?: DeliveryDiscountType
  isActive?: boolean
  branch?: BranchMiniEntity
  page?: number
  limit?: number
}
